import { AnyObjectSchema, ValidationError, ValidateOptions } from 'yup'
import { FormikValues, getIn, setIn, validateYupSchema } from 'formik'
interface CustomYupValidateOption extends ValidateOptions {
  showMultipleFieldErrors: boolean
}

export const yupToFormErrors = (
  yupError: ValidationError,
  validationSchemaOptions: CustomYupValidateOption
): undefined | Record<string, string[]> => {
  let errors: Record<string, string[]> = {}
  if (yupError.inner.length === 0 && yupError.path) return setIn(errors, yupError.path, yupError.message)

  if (validationSchemaOptions.showMultipleFieldErrors)
    for (const err of yupError.inner) {
      if (err.path) {
        let fieldErrors = getIn(errors, err.path)
        if (!fieldErrors) fieldErrors = []

        fieldErrors.push(err.message)
        errors = setIn(errors, err.path, fieldErrors)
      }
    }
  else
    for (const err of yupError.inner) if (err.path && !errors[err.path]) errors = setIn(errors, err.path, err.message)

  return errors
}

export const validateYupSchemaMultiErrors = async (values: FormikValues, schema: AnyObjectSchema): Promise<unknown> => {
  try {
    await validateYupSchema(values, schema)
  } catch (e) {
    return yupToFormErrors(e as ValidationError, { showMultipleFieldErrors: true })
  }
}
